module.exports = __webpack_public_path__ + "static/media/studbook.9d455ec8.svg";